const type = 'OPEN_ACCOUNT_BLOCKED_MODAL';

const openAccountBlockedModal = () => ({
  type,
});

export { type };
export default openAccountBlockedModal;
